import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-24 h-12 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/fbd6e293aff082c6551014a76550a28a/ac092ddd5e8296cd231c029d8c3ac0cf.png"
                alt="unuu Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
            >
              About
            </Link>
            <Link
              to="/case-studies"
              className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
            >
              Case Studies
            </Link>
            <Link
              to="/blog"
              className="text-[#00989e] font-medium cursor-pointer"
            >
              Blog
            </Link>
            <Link
              to="/assessment"
              className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
            >
              Assessment
            </Link>
          </div>

          <div className="hidden md:block">
            <Link
              to="/#contact"
              className="px-6 py-2.5 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Started
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-slate-700`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-slate-100 pt-4">
            <div className="flex flex-col gap-4">
              <Link
                to="/"
                className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
              >
                About
              </Link>
              <Link
                to="/case-studies"
                className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
              >
                Case Studies
              </Link>
              <Link
                to="/blog"
                className="text-[#00989e] font-medium cursor-pointer"
              >
                Blog
              </Link>
              <Link
                to="/assessment"
                className="text-slate-600 hover:text-[#00989e] transition-colors cursor-pointer font-medium"
              >
                Assessment
              </Link>
              <Link
                to="/#contact"
                className="px-6 py-2.5 bg-[#00989e] text-white font-semibold rounded-full hover:bg-[#007a7f] transition-colors cursor-pointer whitespace-nowrap text-center"
              >
                Get Started
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
